import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { setFilesReorderingMode } from '../../actions/Files';

import { userCan } from '../../helpers/Auth';
import { getFilesView } from '../../helpers/Files';

const CollectionReorder = ({
  collection,
  collections,
  reorderingMode,
  setReorderingMode,
  size,
}) => {
  const intl = useIntl();
  const filesView = getFilesView();
  const prevCollectionRef = useRef(null);

  useEffect(() => {
    const prevCollection = prevCollectionRef.current;

    if (!collection || prevCollection !== collection) {
      setReorderingMode(false);
    }

    prevCollectionRef.current = collection;
  }, [collection, setReorderingMode]);

  useEffect(
    () => () => {
      setReorderingMode(false);
    },
    [setReorderingMode],
  );

  const shouldDisableReorderSmartCollection = collection && collection.smart;
  const shouldDisableReorderCollectionView = (filesView === 'masonry' || filesView === 'tile') && collections.length === 0;
  const shouldDisableReorder =
    shouldDisableReorderSmartCollection || shouldDisableReorderCollectionView;

  if (!(collection && userCan('collection.reorder', collection))) return null;

  return (
    <div id="reorderButtonWrapper" className="button-wrapper">
      <Button
        id="reorderButton"
        className={classnames('transparent-button', { 'transparent-button-primary': reorderingMode })}
        disabled={shouldDisableReorder}
        onClick={(e) => {
          e.preventDefault();
          if (!shouldDisableReorder) {
            setReorderingMode(!reorderingMode);
          }
        }}
        {...(size ? { size } : {})}
      >
        <i className="fal fa-arrows" />
        {reorderingMode && <span>{intl.formatMessage({ defaultMessage: 'Finish Reordering' })}</span>}
      </Button>
      {(shouldDisableReorderSmartCollection) && (
        <UncontrolledTooltip target="reorderButtonWrapper" fade={false} placement="top" boundariesElement="body">
          {intl.formatMessage({ defaultMessage: 'Reordering not allowed in Smart Collections.' })}
        </UncontrolledTooltip>
      )}
      {(!shouldDisableReorderSmartCollection && shouldDisableReorderCollectionView) && (
        <UncontrolledTooltip target="reorderButtonWrapper" fade={false} placement="top" boundariesElement="body">
          {intl.formatMessage({ defaultMessage: 'Switch to grid or list view to reorder files.' })}
        </UncontrolledTooltip>
      )}
      {(!shouldDisableReorder && !reorderingMode) && (
        <UncontrolledTooltip target="reorderButtonWrapper" fade={false} placement="top" boundariesElement="body">
          {intl.formatMessage({ defaultMessage: 'Reorder' })}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  collection: state.Collections.collection,
  collections: state.Collections.collections,
  reorderingMode: state.Files.reorderingMode,
});

const mapDispatchToProps = (dispatch) => ({
  setReorderingMode: (status) => {
    dispatch(setFilesReorderingMode(status));
  },
});

CollectionReorder.propTypes = {
  collection: PropTypes.object,
  collections: PropTypes.array.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
  setReorderingMode: PropTypes.func.isRequired,
  size: PropTypes.string,
};

CollectionReorder.defaultProps = {
  collection: null,
  size: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionReorder);
